/**
 * index.tsx
 * [Readme] --------------------------------------------------------------------------------------
 * 
 * 기본적인 아이콘 일부가 정의
 * 
 * -----------------------------------------------------------------------------------------------
 */

import styled from 'styled-components';
import prev from 'common-modules/general/assets/Desktop/images/common/ico_paginav_prev.png';
import doulbePrev from 'common-modules/general/assets/Desktop/images/common/ico_paginav_first.png';
import nevt from 'common-modules/general/assets/Desktop/images/common/ico_paginav_next.png';
import doulbeNext from 'common-modules/general/assets/Desktop/images/common/ico_paginav_last.png';
import Down from 'common-modules/general/assets/Desktop/images/common/ico_download.png';

export const DownIcon = styled.span`
  position: relative;
  top: 2px;
  display: inline-block;
  margin-right: 10px;
  margin-right: 0.625rem;
  width: 24px;
  width: 1.5rem;
  height: 18px;
  height: 1.125rem;
  background: url(${Down}) no-repeat center top;
`;

export const PrevArrowIcon = styled.div`
  width: 0.5rem;
  height: 0.875rem;
  background: url(${prev}) no-repeat 0 0;
  display: inline-block;
`;

export const PrevDoubleArrowIcon = styled.div`
  width: 0.875rem;
  height: 0.875rem;
  background: url(${doulbePrev}) no-repeat 0 0;

  display: inline-block;
`;

export const NextArrowIcon = styled.div`
  width: 0.5rem;
  height: 0.875rem;
  background: url(${nevt}) no-repeat 0 0;
  display: inline-block;
`;
export const NextDoubleArrowIcon = styled.div`
  width: 0.875rem;
  height: 0.875rem;
  background: url(${doulbeNext}) no-repeat 0 0;
  display: inline-block;
`;
